import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "container-app" }
const _hoisted_2 = { class: "menu-bar" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { class: "container-menus" }
const _hoisted_8 = { class: "titulo-desc" }
const _hoisted_9 = { key: 4 }

import MyNavBar from "@/components/MyNavBar.vue";
import MyFooter from "@/components/MyFooter.vue";
import UserProfile from "@/components/profile/UserProfile.vue";
import { ref } from "vue";

// Definir currentView com todas as opções
const theme = "light";

export default /*@__PURE__*/_defineComponent({
  __name: 'MyProfile',
  setup(__props) {

const currentView = ref<
  "perfil" | "configuracao" | "aparencia-interface" | "oas" | "ajuda-suporte"
>("perfil");

// Função que altera o valor de currentView
const setView = (
  view:
    | "perfil"
    | "configuracao"
    | "aparencia-interface"
    | "oas"
    | "ajuda-suporte"
) => {
  currentView.value = view;
};


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", null, [
      _createVNode(MyNavBar, { theme: theme })
    ]),
    _cache[13] || (_cache[13] = _createElementVNode("section", { id: "header-section" }, [
      _createElementVNode("div", { class: "header-content" }, [
        _createElementVNode("h1", null, "Configurações"),
        _createElementVNode("h2", null, "Personalize suas preferências e gerencie seu perfil.")
      ])
    ], -1)),
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (setView('perfil'))),
          class: _normalizeClass({ active: currentView.value === 'perfil' })
        }, " Perfil de Usuário ", 2),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (setView('configuracao'))),
          class: _normalizeClass({ active: currentView.value === 'configuracao' })
        }, " Configurações de Conta ", 2),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (setView('aparencia-interface'))),
          class: _normalizeClass({ active: currentView.value === 'aparencia-interface' })
        }, " Aparência e Interface ", 2),
        _createElementVNode("button", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (setView('oas'))),
          class: _normalizeClass({ active: currentView.value === 'oas' })
        }, " Objeto de Aprendizagem ", 2),
        _createElementVNode("button", {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (setView('ajuda-suporte'))),
          class: _normalizeClass({ active: currentView.value === 'ajuda-suporte' })
        }, " Ajuda e Suporte ", 2)
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "separator" }, null, -1))
    ]),
    (currentView.value === 'perfil')
      ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
          _createVNode(UserProfile)
        ]))
      : _createCommentVNode("", true),
    (currentView.value === 'configuracao')
      ? (_openBlock(), _createElementBlock("section", _hoisted_4, _cache[6] || (_cache[6] = [
          _createElementVNode("div", { class: "container-menus" }, [
            _createElementVNode("div", { class: "titulo-desc" }, [
              _createElementVNode("h1", null, "Configurações de Conta"),
              _createElementVNode("h2", null, "Opções de conta relacionadas ao seu acesso à conta.")
            ]),
            _createElementVNode("div")
          ], -1)
        ])))
      : _createCommentVNode("", true),
    (currentView.value === 'aparencia-interface')
      ? (_openBlock(), _createElementBlock("section", _hoisted_5, _cache[7] || (_cache[7] = [
          _createElementVNode("div", { class: "container-menus" }, [
            _createElementVNode("div", { class: "titulo-desc" }, [
              _createElementVNode("h1", null, "Aparência e Interface"),
              _createElementVNode("h2", null, "Ajustes relacionados à aparência da interface de usuário.")
            ]),
            _createElementVNode("div")
          ], -1)
        ])))
      : _createCommentVNode("", true),
    (currentView.value === 'oas')
      ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[9] || (_cache[9] = _createElementVNode("h1", null, "Objetos de Aprendizagem", -1)),
              _cache[10] || (_cache[10] = _createElementVNode("h2", null, " Configurações relacionada à submissão de Objetos de Aprendizagem. ", -1)),
              false
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    class: "button-submisao",
                    to: "create-oa"
                  }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createTextVNode(" Nova submissão ")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _cache[11] || (_cache[11] = _createElementVNode("div", null, null, -1))
          ])
        ]))
      : _createCommentVNode("", true),
    (currentView.value === 'ajuda-suporte')
      ? (_openBlock(), _createElementBlock("section", _hoisted_9, _cache[12] || (_cache[12] = [
          _createElementVNode("div", { class: "container-menus" }, [
            _createElementVNode("div", { class: "titulo-desc" }, [
              _createElementVNode("h1", null, "Ajuda e Suporte"),
              _createElementVNode("h2", null, " Gerencie as informações do seu perfil pessoal, que é exibido para outros usuários. ")
            ]),
            _createElementVNode("div")
          ], -1)
        ])))
      : _createCommentVNode("", true),
    _createElementVNode("section", null, [
      _createVNode(MyFooter)
    ])
  ]))
}
}

})